import { KeyValue, KeyValueGeneric } from '@/main/models/common';
import { InventoryFileTypeEnum } from '../enum/InventoryFileTypeEnum';
import { ScoreRatingEnum } from '../enum/ScoreRatingEnum';
import { StatusActiveGeneralEnum } from '../enum/StatusActiveGeneralEnum';
import { StatusIntegrationCompanyEnum } from '../enum/StatusIntegrationCompanyEnum';
import { StatusIntegrationLogEnum } from '../enum/StatusIntegrationLogEnum';
import { StatusManagePackagesEnum } from '../enum/StatusManagePackagesEnum';
import { StatusRegisterEnum } from '../enum/StatusRegisterEnum';
import { StatusUserEnum } from '../enum/StatusUserEnum';
import { getTranslateByKey } from '../utils';

export function getOptionsStatusUser(): KeyValue[] {
  return [
    {
      key: StatusUserEnum.Active,
      value: getTranslateByKey('statusUser.active')
    },
    {
      key: StatusUserEnum.Blocked,
      value: getTranslateByKey('statusUser.blocked')
    },
    {
      key: StatusUserEnum.Suspended,
      value: getTranslateByKey('statusUser.suspended')
    }
  ];
}

export function getOptionsStatus(): KeyValue[] {
  return [
    {
      key: StatusRegisterEnum.Active,
      value: getTranslateByKey('statusUser.active')
    },
    {
      key: StatusRegisterEnum.Suspended,
      value: getTranslateByKey('statusUser.suspended')
    }
  ];
}
export function getOptionsStatusIntegrationCompany(): KeyValueGeneric<
  StatusIntegrationCompanyEnum,
  string
>[] {
  return [
    {
      key: StatusIntegrationCompanyEnum.Active,
      value: getTranslateByKey('statusUser.active')
    },
    {
      key: StatusIntegrationCompanyEnum.Suspended,
      value: getTranslateByKey('statusUser.suspended')
    }
  ];
}

export function getOptionsStatusActiveGeneral(): KeyValue[] {
  return [
    {
      key: StatusActiveGeneralEnum.Active,
      value: getTranslateByKey('statusUser.active')
    },
    {
      key: StatusActiveGeneralEnum.Inactive,
      value: getTranslateByKey('information.inactive')
    }
  ];
}

export function getIntegrationsLogOptionsStatus(): KeyValue[] {
  return [
    {
      key: StatusIntegrationLogEnum.Success,
      value: getTranslateByKey('supplierInventoryImportStatus.success')
    },
    {
      key: StatusIntegrationLogEnum.Error,
      value: getTranslateByKey('supplierInventoryImportStatus.error')
    }
  ];
}

export function getManagePackagesStatus(): KeyValue[] {
  return [
    {
      key: StatusManagePackagesEnum.OnTrack,
      value: getTranslateByKey('information.onTrack')
    },
    {
      key: StatusManagePackagesEnum.AtRisk,
      value: getTranslateByKey('information.atRisk')
    },
    {
      key: StatusManagePackagesEnum.Delayed,
      value: getTranslateByKey('information.delayed')
    }
  ];
}

export function getStars(): KeyValue[] {
  return [
    {
      key: ScoreRatingEnum.Unsatisfactory,
      value: getTranslateByKey('information.unsatisfactory')
    },
    {
      key: ScoreRatingEnum.Bad,
      value: getTranslateByKey('information.bad')
    },
    {
      key: ScoreRatingEnum.Good,
      value: getTranslateByKey('information.good')
    },
    {
      key: ScoreRatingEnum.Satisfactory,
      value: getTranslateByKey('information.satisfactory')
    },
    {
      key: ScoreRatingEnum.Excellent,
      value: getTranslateByKey('information.excellent')
    }
  ];
}

export const getOptionsInventoryFileType = (): KeyValue[] => [
  {
    key: InventoryFileTypeEnum.Import,
    value: getTranslateByKey('inventory.importSchedule')
  },
  {
    key: InventoryFileTypeEnum.Export,
    value: getTranslateByKey('inventory.export')
  }
];

export function getOptionsStatusRegisterActiveInactive(): KeyValue[] {
  return [
    {
      key: StatusRegisterEnum.Active,
      value: getTranslateByKey('statusUser.active')
    },
    {
      key: StatusRegisterEnum.Suspended,
      value: getTranslateByKey('statusUser.suspended')
    }
  ];
}
